
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="px-8 py-12 mt-20 border-t border-white/5 bg-black/50">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 accent-gradient rounded flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <span className="font-display text-lg font-bold tracking-tighter uppercase">deal<span className="text-blue-500">mycar</span></span>
        </div>

        <div className="flex gap-8 text-xs font-bold uppercase tracking-widest text-gray-500">
          <a href="#" className="hover:text-white transition-colors">Privacy</a>
          <a href="#" className="hover:text-white transition-colors">Terms</a>
          <a href="#" className="hover:text-white transition-colors">Contact</a>
        </div>

        <p className="text-xs text-gray-600">
          © {new Date().getFullYear()} dealmycar India. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
